export default __webpack_public_path__ + "static/bunker-pages-1-8317110319b65e59d878dd08d3431b30.jpg";